import React from 'react';
import { Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import text from '../../text';
var VersioningAlert = function() {
    var outdated = useSelector(function(state) {
        return state.alerts.outdated;
    });
    if (!outdated) {
        return null;
    }
    var onReload = function(event) {
        event.preventDefault();
        window.location.reload();
    };
    return /*#__PURE__*/ React.createElement(Alert, {
        show: true,
        variant: "warning",
        dismissible: false
    }, text('versionOutdated', {
        link: function(value) {
            return /*#__PURE__*/ React.createElement(Alert.Link, {
                key: "versionOutdated",
                onClick: onReload
            }, value);
        }
    }));
};
export default VersioningAlert;
